import { gql } from '@apollo/client'

export const GENERATE_TENANT_MUTATION = gql`
  mutation GenerateTenant($input: TenantInput!) {
    generateTenant(input: $input) {
      message
    }
  }
`
